<template>
  <div id="app">
    <notifications></notifications>
    <router-view></router-view>
  </div>
</template>

<script>
/**
 * App - Root component
 * @description Main application wrapper with theme initialization
 */
export default {
  name: "App",
  mounted() {
    this.initializeTheme();
  },
  methods: {
    /**
     * Initializes theme from localStorage or system preference
     */
    initializeTheme() {
      try {
        const saved = localStorage.getItem("kemaris-theme");
        if (saved) {
          document.documentElement.setAttribute("data-theme", saved);
        } else {
          // Check system preference
          const prefersDark = window.matchMedia(
            "(prefers-color-scheme: dark)"
          ).matches;
          document.documentElement.setAttribute(
            "data-theme",
            prefersDark ? "dark" : "light"
          );
        }
      } catch (e) {
        console.warn("[App] Could not initialize theme:", e);
        document.documentElement.setAttribute("data-theme", "light");
      }
    },
  },
};
</script>

<style lang="scss">
#app {
  min-height: 100vh;
}

/* Global resets for Apple-style */
* {
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  margin: 0;
  padding: 0;
  background: var(--k-bg-secondary);
  color: var(--k-text-primary);
  transition: background-color 0.25s ease-out, color 0.25s ease-out;
}

/* Selection color */
::selection {
  background: rgba(0, 122, 255, 0.3);
  color: inherit;
}

/* Scrollbar styling */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: var(--k-border-color-strong);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--k-text-tertiary);
}

/* Focus visible for accessibility */
:focus-visible {
  outline: 2px solid var(--k-accent);
  outline-offset: 2px;
}
</style>
